<template>
  <div
    class="base-heading"
    :class="sizeClass"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseHeading',
  props: {
    level: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    sizeClass() {
      return `base-heading--size-${this.level}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-heading {
  font-family: 'Tiempos Headline';
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 0.75rem;
  color: #1b1b1b;
  letter-spacing: 0.19px;
  width: 100%;

  &--size-1 {
    // font-size: 2.25rem;
    font-size: 1.875rem;
  }
  &--size-2 {
    font-size: 1.25rem;
  }
  &--size-3 {
    font-size: 1rem;
  }
  &--size-4 {
    font-size: 0.85rem;
  }
  &--size-5 {
    font-size: 0.75rem;
  }
}
</style>
